<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ this.route.menuName }}</span>
        <span v-if="$route.query.binding" class="prompt">该供应商产品已绑定证件，请切换至证件信息分页进行审批。</span>
      </div>

      <el-tabs v-model="activeName">
        <el-tab-pane label="基础信息" name="1">
          <el-form ref="form" :model="form" label-position="top" :rules="rules" label-width="100px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="供应商" prop="supplierName">
                  <el-input disabled v-model="form.supplierName"></el-input>
                </el-form-item>
              </el-col>
              <el-col v-show="Boolean(form.oldId)" :span="6">
                <el-form-item label="供应商产品编码">
                  <el-input disabled v-model="form.oldSupplierProductNo"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="edit-card" v-show="Boolean(form.oldId)">
              <div style="width: 88%; display: flex">
                <div class="start-label" />
                <span class="text">旧产品基本信息</span>
              </div>
              <el-row>
                <el-col :span="5">
                  <el-form-item prop="oldProductName" label="产品名称">
                    <el-input disabled v-model="form.oldProductName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="规格型号">
                    <el-input disabled v-model="form.oldSpecName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="oldProductCommonName" label="别名">
                    <el-input disabled v-model="form.oldProductCommonName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="注册证名称">
                    <el-input disabled v-model="form.oldProductRegistCertName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="注册证号">
                    <el-input disabled v-model="form.oldProductRegistCertNo"></el-input>
                  </el-form-item>
                </el-col>

              </el-row>

              <el-row>
                <el-col :span="5">
                  <el-form-item label="生产厂家">
                    <el-input disabled v-model="form.oldManufacturerName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="售后代理商">
                    <el-input disabled v-model="form.oldAgentName"></el-input>
                  </el-form-item>
                </el-col>
                  <el-col :span="5">
                      <el-form-item label="注册备案人">
                        <el-input disabled v-model="form.oldRegistrantUserName"></el-input>
                      </el-form-item>
                    </el-col>
              </el-row>
            </div>
            <div class="edit-card">
              <div style="width: 88%; display: flex">
                <div class="start-label" />
                <span class="text">产品基本信息</span>
              </div>
              <el-row>
                <el-col :span="5">
                  <el-form-item prop="productName" label="产品名称">
                    <el-input disabled v-model="form.productName" :class="Boolean(form.oldId) && form.productName != form.oldProductName ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="规格型号">
                    <el-input disabled v-model="form.specName" :class="Boolean(form.oldId) && form.specName != form.oldSpecName ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="productCommonName" label="别名">
                    <el-input disabled v-model="form.productCommonName" :class="Boolean(form.oldId) && form.productCommonName != form.oldProductCommonName ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="注册证名称">
                    <el-input disabled v-model="form.productRegistCertName" :class="Boolean(form.oldId) && form.productRegistCertName != form.oldProductRegistCertName ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="注册证号">
                    <el-input disabled v-model="form.productRegistCertNo" :class="Boolean(form.oldId) && form.productRegistCertNo != form.oldProductRegistCertNo ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>

              </el-row>

              <el-row>
                <el-col :span="5">
                  <el-form-item label="生产厂家">
                    <el-input disabled v-model="form.manufacturerName" :class="Boolean(form.oldId) && form.manufacturerName != form.oldManufacturerName ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="售后代理商">
                    <el-input disabled v-model="form.agentName"></el-input>
                  </el-form-item>
                </el-col>
                 <el-col :span="5">
                      <el-form-item label="注册备案人">
                        <el-input disabled v-model="form.registrantUserName"></el-input>
                      </el-form-item>
                    </el-col>
              </el-row>
            </div>
            <div class="edit-card" v-show="Boolean(form.oldId)">
              <div style="width: 88%; display: flex">
                <div class="start-label" />
                <span class="text">旧产品附属信息</span>
              </div>
              <el-row>
                <el-col :span="4">
                  <el-form-item label="医保代码">
                    <el-input disabled v-model="form.oldMedicalInsuranceCategoryNo"></el-input>
                  </el-form-item>
                </el-col>
                   <el-col :span="4">
                  <el-form-item label="医保码启用日期">
                    <el-input disabled v-model="form.oldMediActiDate"></el-input>
                  </el-form-item>
                </el-col>
                
                <el-col :span="4">
                  <el-form-item label="一级分类">
                    <el-input disabled v-model="form.oldFirstCategory"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="二级分类">
                    <el-input disabled v-model="form.oldSecondCategory"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="三级分类">
                    <el-input disabled v-model="form.oldThirdCategory"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="医保通用名">
                    <el-input disabled v-model="form.oldMedicalInsuranceCommonName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="材质">
                    <el-input disabled v-model="form.oldTexture"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="特征">
                    <el-input disabled v-model="form.oldProperties"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="单件产品名称">
                    <el-input disabled v-model="form.oldSingleProductName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="医保代码(27位)" prop="oldMedicalInsuranceCategoryLongNo">
                    <el-input disabled v-model="form.oldMedicalInsuranceCategoryLongNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="brand" label="品牌">
                    <el-input disabled v-model="form.oldBrand"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4">
                  <el-form-item label="包装单位">
                    <el-input disabled v-model="form.oldUnit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="最小单位">
                    <el-input disabled v-model="form.oldMinUnit"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="4">
                  <el-form-item prop="brand" label="件装量" class="packNumBox">

                    <el-input disabled v-model="form.oldPackNumber"></el-input>
                    &nbsp;&nbsp;
                    <el-input disabled :value="(form.oldMinUnit+'/'+form.oldUnit)"></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="包装规格">
                    <el-input disabled v-model="form.oldPackSpec"></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="4">
              <el-form-item label="集采批次">
                <el-input disabled v-model="form.oldDistributionBatchName"></el-input>
              </el-form-item>
            </el-col> -->
                <el-col :span="4">
                  <el-form-item prop="oldUseTime" label="使用次数">
                    <el-input disabled v-model="form.oldUseTime"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="oldIsDistribution" label="是否集采">
                    <el-select v-model="form.oldIsDistribution" disabled style="width:100%">
                      <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <!-- <el-checkbox disabled v-model="form.oldIsDistribution"></el-checkbox> -->
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="oldIsScan" label="是否扫码">
                    <el-select v-model="form.isScoldIsScanan" disabled style="width:100%">
                      <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <!-- <el-checkbox disabled v-model="form.oldIsScan"></el-checkbox> -->
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="onlineNo" label="挂网号">
                    <el-input disabled v-model="form.oldOnlineNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="新挂网号">
                    <el-input disabled v-model="form.oldNewOnlineNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="isOnline" label="是否挂网">
                    <el-select disabled  v-model="form.oldIsOnline"  
                      style="width: 100%">
                      <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="商品代码">
                    <el-input disabled v-model="form.oldProductCode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="产品ID">
                    <el-input disabled v-model="form.oldNewProductId"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="分类ID">
                    <el-input disabled v-model="form.oldPlatformCategoryId"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="oldPurchasePrice" label="采购价">
                    <el-input disabled v-model="form.oldPurchasePrice"></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="4">
                  <el-form-item prop="oldBillingPrice" label="计费价">
                    <el-input disabled v-model="form.oldBillingPrice"></el-input>
                  </el-form-item>
                </el-col> -->
                <el-col :span="4">
                  <el-form-item prop="oldOnlinePrice" label="挂网价">
                    <el-input disabled v-model="form.oldOnlinePrice"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="oldIsTempPurchase" label="临采标识">
                    <el-select v-model="form.oldIsTempPurchase" disabled style="width:100%">
                      <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="4">
                  <el-form-item prop="distributionBatchId" label="集采批次">
                    <el-select v-model="form.oldDistributionBatchName" disabled clearable placeholder="请选择集采批次" style="width: 100%" @change="distributionBatchChange">
                      <el-option v-for="item in STATIC_DistributionBatchs" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item prop="servicefee " label="伴随服务费">
                    <el-input disabled v-model="form.oldServicefee"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item prop="singleItemPrice" label="单品价格">
                    <el-input disabled v-model="form.oldSingleItemPrice"></el-input>
                  </el-form-item>
                </el-col> -->
                <el-col :span="4">
                  <el-form-item prop="oldSaleCategory" label="销售类型">
                    <el-radio-group v-model="form.oldSaleCategory" disabled>
                      <el-radio v-for="item in SaleCategoryOptions" :key="item.id" :label="item.id" :value="item.id">{{ item.name }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="产地类型" prop="oldProductionPlaceType">
                    <el-select v-model="form.oldProductionPlaceType" disabled style="width:100%">
                      <el-option v-for="item in ProductionPlaceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="oldDangerLevel" label="风险等级">
                    <el-select v-model="form.oldDangerLevel" disabled style="width:100%">
                      <el-option v-for="item in DangerLevelCategoryOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="oldStorageMode" label="存储方式">
                    <el-select v-model="form.oldStorageMode" disabled style="width:100%">
                      <el-option v-for="item in StorageModeCategoryOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="oldContractNo" label="合同号">
                    <el-input disabled v-model="form.oldContractNo"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="oldContractDate" label="合同日期">
                    <el-date-picker disabled v-model="form.oldContractDate" type="daterange" format="yyyy-MM-dd" style="width:100%" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="oldComponentLocation" label="部件部位">
                    <el-input disabled v-model="form.oldComponentLocation"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="oldIsSelected" label="中选">
                    <el-select v-model="form.oldIsSelected" disabled style="width:100%">
                      <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                
                <!-- <el-col :span="4">
                  <el-form-item prop="oldOtherCategoryName" label="其他分类">
                    <el-input disabled v-model="form.oldOtherCategoryName"></el-input>
                  </el-form-item>
                </el-col> -->

              </el-row>
            </div>
            <div class="edit-card">
              <div style="width: 88%; display: flex">
                <div class="start-label" />
                <span class="text">产品附属信息</span>
              </div>
              <el-row>
                <el-col :span="4">
                  <el-form-item label="医保代码">
                    <el-input disabled v-model="form.medicalInsuranceCategoryNo" :class="Boolean(form.oldId) && form.medicalInsuranceCategoryNo != form.oldMedicalInsuranceCategoryNo ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="医保码启用日期">
                     <el-date-picker  v-model="form.mediActiDate" :class="Boolean(form.oldId) && form.mediActiDate != form.oldMediActiDate ? 'change-content' : ''"  type="date" format="yyyy-MM-dd" style="width:100%" value-format="yyyy-MM-dd" >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="firstCategory" label="一级分类">
                    <el-input disabled v-model="form.firstCategory" :class="Boolean(form.oldId) && form.firstCategory != form.oldFirstCategory ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="secondCategory" label="二级分类">
                    <el-input disabled v-model="form.secondCategory" :class="Boolean(form.oldId) && form.secondCategory != form.oldSecondCategory ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="thirdCategory" label="三级分类">
                    <el-input disabled v-model="form.thirdCategory" :class="Boolean(form.oldId) && form.thirdCategory != form.oldThirdCategory ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="医保通用名">
                    <el-input disabled v-model="form.medicalInsuranceCommonName" :class="Boolean(form.oldId) && form.medicalInsuranceCommonName != form.oldMedicalInsuranceCommonName ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="材质">
                    <el-input disabled v-model="form.texture" :class="Boolean(form.oldId) && form.texture != form.oldTexture ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="特征">
                    <el-input disabled v-model="form.properties" :class="Boolean(form.oldId) && form.properties != form.oldProperties ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="单件产品名称">
                    <el-input disabled v-model="form.singleProductName" :class="Boolean(form.oldId) && form.singleProductName != form.oldSingleProductName ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="医保代码(27位)" prop="medicalInsuranceCategoryLongNo" label-width="135px">
                    <el-input disabled v-model="form.medicalInsuranceCategoryLongNo" :class="Boolean(form.oldId) && form.medicalInsuranceCategoryLongNo != form.oldMedicalInsuranceCategoryLongNo ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="brand" label="品牌">
                    <el-input disabled v-model="form.brand" :class="Boolean(form.oldId) && form.brand != form.oldBrand ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="4">
                  <el-form-item label="包装单位">
                    <el-input disabled v-model="form.unit" :class="Boolean(form.oldId) && form.unit != form.oldUnit ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="最小单位">
                    <el-input disabled v-model="form.minUnit" :class="Boolean(form.oldId) && form.minUnit != form.oldMinUnit ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="brand" label="件装量" class="packNumBox">

                    <el-input disabled v-model="form.packNumber" :class="Boolean(form.oldId) && form.brand != form.oldBrand ? 'change-content' : ''"></el-input>
                    &nbsp;&nbsp;
                    <el-input disabled :value="(form.minUnit+'/'+form.unit)"></el-input>

                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="包装规格">
                    <el-input disabled v-model="form.packSpec" :class="Boolean(form.oldId) && form.packSpec != form.oldPackSpec ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="4">
              <el-form-item label="集采批次">
                <el-input disabled v-model="form.distributionBatchName" :class="Boolean(form.oldId)&& form.distributionBatchName!= form.oldDistributionBatchName? 'change-content' : ''"></el-input>
              </el-form-item>
            </el-col> -->
                <el-col :span="4">
                  <el-form-item prop="useTime" label="使用次数">
                    <el-input disabled v-model="form.useTime" :class="Boolean(form.oldId) && form.useTime != form.oldUseTime ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="2">
                  <el-form-item prop="isTempPurchase" label="临采标识">
                    <el-select v-model="form.isTempPurchase" disabled :class="Boolean(form.oldId) && form.isTempPurchase != form.oldIsTempPurchase ? 'change-content' : ''" style="width:100%">
                      <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="2" v-if="form.isTempPurchase==1&&!form.oldId">
                  <el-form-item prop="sporadicNumber" label="临采数量">
                    <el-input :disabled="!editMode && showWorkFlowInfo" v-model="form.sporadicNumber" :class="Boolean(form.oldId) && form.sporadicNumber != form.oldSporadicNumber ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="isScan" label="是否扫码">
                    <el-select v-model="form.isScan" disabled :class="Boolean(form.oldId) && form.isScan != form.oldIsScan ? 'change-content' : ''" style="width:100%">
                      <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <!-- <el-checkbox disabled v-model="form.isScan" :class="Boolean(form.oldId)&& form.isScan!= form.oldIsScan? 'change-content' : ''"></el-checkbox> -->
                  </el-form-item>
                </el-col>

                <el-col :span="4">
                  <el-form-item prop="onlineNo" label="挂网号">
                    <el-input disabled v-model="form.onlineNo" :class="Boolean(form.oldId) && form.onlineNo != form.oldOnlineNo ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="新挂网号">
                    <el-input disabled v-model="form.newOnlineNo" :class="Boolean(form.oldId) && form.newOnlineNo != form.oldNewOnlineNo ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                    <el-col :span="4">
                     <el-form-item prop="isOnline" label="是否挂网">
                    <el-select disabled :class="Boolean(form.oldId) && form.isOnline != form.oldIsOnline ? 'change-content' : ''" v-model="form.isOnline"  
                      style="width: 100%">
                      <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="商品代码">
                    <el-input disabled v-model="form.productCode" :class="Boolean(form.oldId) && form.productCode != form.oldProductCode ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="产品ID">
                    <el-input disabled v-model="form.newProductId" :class="Boolean(form.oldId) && form.newProductId != form.oldNewProductId ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="分类ID">
                    <el-input disabled v-model="form.platformCategoryId" :class="Boolean(form.oldId) && form.platformCategoryId != form.oldPlatformCategoryId ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item prop="saleCategory" label="销售类型">
                    <el-radio-group v-model="form.saleCategory" disabled :class="Boolean(form.oldId) && form.saleCategory != form.oldSaleCategory ? 'change-content' : ''">
                      <el-radio v-for="item in SaleCategoryOptions" :key="item.id" :label="item.id" :value="item.id">{{ item.name }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item prop="purchasePrice" label="采购价">
                    <el-input disabled v-model="form.purchasePrice" :class="Boolean(form.oldId) && form.purchasePrice != form.oldPurchasePrice ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="4">
                  <el-form-item prop="billingPrice" label="计费价">
                    <el-input disabled v-model="form.billingPrice" :class="Boolean(form.oldId)&& form.billingPrice!= form.oldBillingPrice? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col> -->
                <el-col :span="4">
                  <el-form-item prop="onlinePrice" label="挂网价">
                    <el-input disabled v-model="form.onlinePrice" :class="Boolean(form.oldId) && form.onlinePrice != form.oldOnlinePrice ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="isDistribution" label="是否集采">
                    <el-select v-model="form.isDistribution" disabled :class="Boolean(form.oldId) && form.isDistribution != form.oldIsDistribution ? 'change-content' : ''" style="width:100%">
                      <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <!-- <el-checkbox disabled v-model="form.isDistribution" :class="Boolean(form.oldId)&& Boolean(form.isDistribution)!= Boolean(form.oldIsDistribution)? 'change-content' : ''"></el-checkbox> -->
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="distributionBatchId" label="集采批次">
                    <el-select v-model="form.distributionBatchName" :disabled="!editMode && !showWorkFlowInfo" clearable placeholder="请选择集采批次" style="width: 100%" @change="distributionBatchChange">
                      <el-option v-for="item in STATIC_DistributionBatchs" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item prop="servicefee " label="伴随服务费">
                    <el-input disabled v-model="form.servicefee"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item prop="singleItemPrice" label="单品价格">
                    <el-input disabled v-model="form.singleItemPrice"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="产地类型" prop="productionPlaceType">
                    <el-select v-model="form.productionPlaceType" disabled style="width:100%" :class="Boolean(form.oldId) && form.productionPlaceType != form.oldProductionPlaceType ? 'change-content' : ''">
                      <el-option v-for="item in ProductionPlaceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="dangerLevel" label="风险等级">
                    <el-select v-model="form.dangerLevel" disabled style="width:100%" :class="Boolean(form.oldId) && form.dangerLevel != form.oldDangerLevel ? 'change-content' : ''">
                      <el-option v-for="item in DangerLevelCategoryOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="storageMode" label="存储方式">
                    <el-select v-model="form.storageMode" disabled style="width:100%" :class="Boolean(form.oldId) && form.storageMode != form.oldStorageMode ? 'change-content' : ''">
                      <el-option v-for="item in StorageModeCategoryOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="contractNo" label="合同号">
                    <el-input disabled v-model="form.contractNo" :class="Boolean(form.oldId) && form.contractNo != form.oldContractNo ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="contractDate" label="合同效期">
                    <el-date-picker disabled v-model="form.contractDate" :class="Boolean(form.oldId) && (form.contractDate[0] != form.oldContractDate[0] || form.contractDate[1] != form.oldContractDate[1]) ? 'change-content' : ''" type="daterange" format="yyyy-MM-dd" style="width:100%" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                 <el-col :span="4 ">
                <el-form-item  prop="componentLocation" label="部件部位">
                <el-input disabled v-model="form.componentLocation"
                  ></el-input>
              </el-form-item>
              </el-col>
                <el-col :span="4">
                  <el-form-item prop="isSelected" label="中选">
                    <el-select v-model="form.isSelected" disabled :class="Boolean(form.oldId) && form.isSelected != form.oldIsSelected ? 'change-content' : ''" style="width:100%">
                      <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="4">
                  <el-form-item prop="otherCategoryName" label="其他分类">
                    <el-input disabled v-model="form.otherCategoryName" :class="Boolean(form.oldId) && form.otherCategoryName != form.oldOtherCategoryName ? 'change-content' : ''"></el-input>
                  </el-form-item>
                </el-col> -->
                <el-col :span="4" v-if="!form.oldId">
                <el-form-item label="病案分类" prop="patientCategory">
                  <!-- :disabled="!editMode && !showWorkFlowInfo" -->
                  <el-select  v-model="form.patientCategory" :disabled="!editMode && showWorkFlowInfo"
                    :filterMethod="getMedicalRecordCategorys" filterable placeholder="请选择病案分类" style="width: 100%">
                    <el-option v-for="item in STATIC_MedicalRecordCategorys" :key="item.id" :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              </el-row>
            </div>

            <div class="edit-card">
              <div style="width: 88%; display: flex">
                <div class="start-label" />
                <span class="text">其他信息</span>
              </div>
              <el-row style="margin-top:10px">
                <el-col :span="6">
                  <el-form-item prop="remark" label="备注">
                    <el-input disabled v-model="form.remark"></el-input>
                  </el-form-item>
                </el-col>
                   <el-col :span="6" v-if="!form.oldId">
                  <el-form-item prop="archiveType" label="建档类型">
                    <el-select v-model="form.archiveType" placeholder="请选择建档类型" style="width:100%" >
                      <el-option v-for="item in ArchiveTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="拒绝原因" prop="reason">
                    <el-input :disabled="form.state != 0" v-model="form.reason" placeholder="拒绝原因"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="证件信息" name="2">

          <div class="edit-card">
            <div style="width: 88%; display: flex">
              <div class="start-label" />
              <span class="text">生产厂商资质信息</span>
            </div>
            <el-table :data="form.manufacturerCertDetails" border style="width: auto; margin: 0 10px" class="table" width="100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
              <el-table-column width="150" prop="no" label="证件编号"></el-table-column>
              <el-table-column width="150" prop="categoryName" label="证件类型"></el-table-column>
              <el-table-column width="150" prop="name" label="证件名称"></el-table-column>
              <el-table-column width="150" prop="manufacturerName" label="生产厂家"></el-table-column>
              <el-table-column width="130" prop="startDate" label="许可开始日期">
                <template slot-scope="scope">
                  {{ scope.row.startDate ? parseTime(new Date(scope.row.startDate), '{y}-{m}-{d}') : '' }}
                  <!-- {{scope.row.startDate?  new Date(scope.row.startDate).format('yyyy-MM-dd hh:mm:ss'): ''}} -->
                </template>
              </el-table-column>
              <el-table-column width="130" prop="endDate" label="许可结束日期">
                <template slot-scope="scope">
                  {{ scope.row.endDate ? parseTime(new Date(scope.row.endDate), '{y}-{m}-{d}') : '' }}
                  <!-- {{scope.row.endDate?  new Date(scope.row.endDate).format('yyyy-MM-dd hh:mm:ss') : ''}} -->
                </template>
              </el-table-column>
              <el-table-column width="80" label="效期状态" align="center" prop="overdueName" />
              <el-table-column prop="phone" label="证件扫描件" width="100">
                <template slot-scope="scope">
                  <div v-for="file in scope.row.fileInfos" :key="file.id">
                    <el-button type="text" size="medium" @click="privewImg(file)">{{ file.name }}</el-button>
                    <!-- <el-image-viewer :filePath="file.path" :fileName="file.name" /> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="拒绝原因" show-overflow-tooltip align="center" prop="reason">
                <template slot-scope="scope">
                  <el-input :disabled="form.state == 0 && scope.row.state !== 0" placeholder="请输入拒绝原因" v-model="scope.row.reason"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="审批状态" width="80" align="center" prop="stateName" />
              <el-table-column label="备注" show-overflow-tooltip align="center" prop="remark"></el-table-column>
              <el-table-column label="操作" align="center" fixed="right" width="140" class-name="small-padding fixed-width">
                <template slot-scope="scope" v-if="form.state == 0 && scope.row.state == 0">
                  <el-button size="mini" type="text" icon="el-icon-check" v-if="scope.row.state != 3 && scope.row.state != 4" @click="handleApprove(scope.row, 3)">通过</el-button>
                  <el-button size="mini" type="text" icon="el-icon-close" v-if="scope.row.state != 3 && scope.row.state != 4" @click="handleApprove(scope.row, 4)">拒绝</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="height:20px"></div>
          </div>
          <div class="edit-card">
            <div style="width: 88%; display: flex">
              <div class="start-label" />
              <span class="text">产品注册证信息</span>
            </div>
            <el-table :data="form.productRegistCertDetails" border style="width: auto; margin: 0 10px" class="table" width="100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
              <el-table-column width="225" prop="no" label="证件编号"></el-table-column>
              <el-table-column width="225" prop="name" label="证件名称"></el-table-column>
              <el-table-column width="150" prop="manufacturerName" label="生产厂家"></el-table-column>
              <el-table-column width="130" prop="startDate" label="许可开始日期">
                <template slot-scope="scope">
                  {{ scope.row.startDate ? parseTime(new Date(scope.row.startDate), '{y}-{m}-{d}') : '' }}
                </template>
              </el-table-column>
              <el-table-column width="130" prop="endDate" label="许可结束日期">
                <template slot-scope="scope">
                  {{ scope.row.endDate ? parseTime(new Date(scope.row.endDate), '{y}-{m}-{d}') : '' }}
                </template>
              </el-table-column>
              <el-table-column label="效期状态" width="80" align="center" prop="overdueName" />
              <el-table-column prop="phone" label="证件扫描件" width="100">
                <template slot-scope="scope">
                  <div v-for="file in scope.row.fileInfos" :key="file.id">
                    <el-button type="text" size="medium" @click="privewImg(file)">{{ file.name }}</el-button>
                    <!-- <el-image-viewer :filePath="file.path" :fileName="file.name" /> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="拒绝原因" show-overflow-tooltip align="center" prop="reason">
                <template slot-scope="scope">
                  <el-input :disabled="form.state == 0 && scope.row.state !== 0" placeholder="请输入拒绝原因" v-model="scope.row.reason"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="审批状态" width="80" align="center" prop="stateName" />
              <el-table-column label="备注" show-overflow-tooltip align="center" prop="remark"></el-table-column>
              <el-table-column label="操作" align="center" fixed="right" width="140" class-name="small-padding fixed-width">
                <template slot-scope="scope" v-if="form.state == 0 && scope.row.state == 0">
                  <el-button size="mini" type="text" icon="el-icon-check" v-if="scope.row.state != 3 && scope.row.state != 4" @click="handleApprove(scope.row, 3)">通过</el-button>
                  <el-button size="mini" type="text" icon="el-icon-close" v-if="scope.row.state != 3 && scope.row.state != 4" @click="handleApprove(scope.row, 4)">拒绝</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="edit-card">
            <div style="width: 88%; display: flex">
              <div class="start-label" />
              <span class="text">授权链信息</span>
            </div>
            <el-table :data="form.authorizechainDetails" border style="width: auto; margin: 0 10px" class="table" width="100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
              <el-table-column type="selection" width="55" />
              <el-table-column width="150" prop="no" label="授权链编号"></el-table-column>
              <el-table-column label="逐级授权追溯" align="center">
                <template slot-scope="scope">
                  <div class="box">
                    <div>
                      1 . {{ scope.row.manufacturerName }} {{ parseTime(new Date(scope.row.startDate),
                      '{y}-{m}-{d}')}}至{{ parseTime(new Date(scope.row.endDate), '{y}-{m}-{d}') }}
                    </div>
                    <div v-for=" (item, index) in scope.row.details " :key="index">
                      {{ index + 2 }}. {{ item.supplierName }} {{ parseTime(new Date(item.startDate),
                      '{y}-{m}-{d}')}}至{{ parseTime(new Date(item.endDate), '{y}-{m}-{d}') }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="100" prop="startDate" label="生效日期">
                <template slot-scope="scope">
                  {{ scope.row.startDate ? parseTime(new Date(scope.row.startDate), '{y}-{m}-{d}') : '' }}
                </template>
              </el-table-column>
              <el-table-column width="100" prop="endDate" label="失效日期">
                <template slot-scope="scope">
                  {{ scope.row.endDate ? parseTime(new Date(scope.row.endDate), '{y}-{m}-{d}') : '' }}
                </template>
              </el-table-column>
              <el-table-column width="80" label="效期状态" align="center" prop="overdueName" />
                         <el-table-column prop="phone" label="证件扫描件" width="100">
                <template slot-scope="scope">
                  <div v-for="file in scope.row.fileInfos" :key="file.id">
                    <el-button type="text" size="medium" @click.stop="privewImg(file)">{{
                      file.name
                      }}</el-button>
                    <!-- <el-image-viewer :filePath="file.path" :fileName="file.name" /> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="拒绝原因" show-overflow-tooltip align="center" prop="reason">
                <template slot-scope="scope">
                  <el-input :disabled="form.state == 0 && scope.row.state !== 0" placeholder="请输入拒绝原因" v-model="scope.row.reason"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="审批状态" width="80" align="center" prop="stateName" />
              <el-table-column label="备注" show-overflow-tooltip align="center" prop="remark"></el-table-column>
              <el-table-column label="操作" align="center" fixed="right" width="140" class-name="small-padding fixed-width">
                <template slot-scope="scope" v-if="form.state == 0 && scope.row.state == 0">
                  <el-button size="mini" type="text" icon="el-icon-check" v-if="scope.row.state != 3 && scope.row.state != 4" @click="handleApprove(scope.row, 3)">通过</el-button>
                  <el-button size="mini" type="text" icon="el-icon-close" v-if="scope.row.state != 3 && scope.row.state != 4" @click="handleApprove(scope.row, 4)">拒绝</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="edit-card">
            <div style="width: 88%; display: flex">
              <div class="start-label" />
              <span class="text">供应商资质信息</span>
            </div>
            <el-table :data="form.supplierCertDetails" border style="width: auto; margin: 0 10px" class="table" width="100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
              <el-table-column width="150" prop="no" label="证件编号"></el-table-column>
              <el-table-column width="150" prop="categoryName" label="证件类型"></el-table-column>
              <el-table-column width="150" prop="name" label="证件名称"></el-table-column>
              <el-table-column width="150" prop="supplierName" label="供应商"></el-table-column>
              <el-table-column width="130" prop="startDate" label="许可开始日期">
                <template slot-scope="scope">
                  {{ scope.row.startDate ? parseTime(new Date(scope.row.startDate), '{y}-{m}-{d}') : '' }}
                  <!-- {{scope.row.startDate?  new Date(scope.row.startDate).format('yyyy-MM-dd hh:mm:ss'): ''}} -->
                </template>
              </el-table-column>
              <el-table-column width="130" prop="endDate" label="许可结束日期">
                <template slot-scope="scope">
                  {{ scope.row.endDate ? parseTime(new Date(scope.row.endDate), '{y}-{m}-{d}') : '' }}
                  <!-- {{scope.row.endDate?  new Date(scope.row.endDate).format('yyyy-MM-dd hh:mm:ss') : ''}} -->
                </template>
              </el-table-column>
              <el-table-column width="80" label="效期状态" align="center" prop="overdueName" />
              <el-table-column prop="phone" label="证件扫描件" width="100">
                <template slot-scope="scope">
                  <div v-for="file in scope.row.fileInfos" :key="file.id">
                    <el-button type="text" size="medium" @click="privewImg(file)">{{ file.name }}</el-button>
                    <!-- <el-image-viewer :filePath="file.path" :fileName="file.name" /> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="拒绝原因" show-overflow-tooltip align="center" prop="reason">
                <template slot-scope="scope">
                  <el-input :disabled="form.state == 0 && scope.row.state !== 0" placeholder="请输入拒绝原因" v-model="scope.row.reason"></el-input>
                </template>
              </el-table-column>
              remark
              <el-table-column label="备注" show-overflow-tooltip align="center" prop="remark"></el-table-column>
              <el-table-column label="审批状态" width="80" align="center" prop="stateName" />
              <el-table-column label="操作" align="center" fixed="right" width="140" class-name="small-padding fixed-width">
                <template slot-scope="scope" v-if="form.state == 0 && scope.row.state == 0">
                  <el-button size="mini" type="text" icon="el-icon-check" v-if="scope.row.state != 3 && scope.row.state != 4" @click="handleApprove(scope.row, 3)">通过</el-button>
                  <el-button size="mini" type="text" icon="el-icon-close" v-if="scope.row.state != 3 && scope.row.state != 4" @click="handleApprove(scope.row, 4)">拒绝</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

        </el-tab-pane>
      </el-tabs>

      <!-- <WorkFlowButton :status="form.status" :workFlowInstanceId="form.workFlowInstanceId" :approverIds="form.approverIds" :createdUser="form.createdUser" :editButton="editButton" :submitButton="submitButton" :id="form.id" :formAcls="formAcls" :effectCanEdit="true" @Cancel="thisDialogClose" @UpdateEditMode="UpdateEditMode" @saveEdit="saveEdit" @reject="reject"></WorkFlowButton> -->

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="form.state == 0" class="btn primary" type="primary" v-preventReClick @click="approve(3)">通
        过</my-button>
      <el-button v-if="form.state == 0" class="btn default" v-preventReClick @click="approve(4)">拒 绝</el-button>
    </div>

    <el-image-viewer :openViewer="dialogVisible" :fileId="fileId" :fileName="fileName"
      @closeImageViewer="closeImageViewer" />
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetSupplierProductUpdateById,
  ApproveSupplierProductUpdate,
  ApproveSupplierProductUpdateCertDetail,
  GetSupplierProductById,
} from "@/api";
import {
  SaleCategoryOptions,
  ProductionPlaceOptions,
  DangerLevelCategoryOptions,
  StorageModeCategoryOptions,
  WhetherOptions,
  ArchiveTypeOptions
} from "@/enum";
import ApproveInfo from "@/components/approve-info";
import SelectTree from '@/components/select-tree';
import ElImageViewer from "@/components/elImageViewer";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    ApproveInfo,
    SelectTree,
    ElImageViewer
  },
  data () {
    return {
      form: {},
      editMode: false,
      SaleCategoryOptions: SaleCategoryOptions,
      ProductionPlaceOptions: ProductionPlaceOptions,
      DangerLevelCategoryOptions: DangerLevelCategoryOptions,
      StorageModeCategoryOptions: StorageModeCategoryOptions,
      WhetherOptions: WhetherOptions,
      ArchiveTypeOptions,
      rules: {
        hospitalName: [{
          required: true,
          message: '请输入医疗机构名称',
          trigger: 'blur'
        }],
        unit: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        minUnit: [{
          required: true,
          message: '请输入最小单位',
          trigger: 'blur'
        }],
        productCommonName: [{
          required: true,
          message: '请输入产品通用名',
          trigger: 'blur'
        }],
        supplierName: [{
          required: true,
          message: '请选择供应商',
          trigger: 'blur'
        }],
        specName: [{
          required: true,
          message: '请选择产品规格',
          trigger: 'blur'
        }],
        manufacturerName: [{
          required: true,
          message: '请选择生产厂家',
          trigger: 'blur'
        }],
        productionRangeName: [{
          required: true,
          message: '请选择生产范围',
          trigger: 'blur'
        }],
        // category: [
        //   { required: true, message: '请选择耗材类型', trigger: 'blur' }
        // ],
        // purchasePrice: [
        //   { required: true, message: '请输入采购价', trigger: 'blur' }
        // ],
        // billingPrice: [
        //   { required: true, message: '请输入计费价', trigger: 'blur' }
        // ],
        // onlinePrice: [
        //   { required: true, message: '请输入挂网价', trigger: 'blur' }
        // ]
      },
      activeName: '1',
      dialogVisible: false,
      fileName: "",
      fileId: 0,
    };
  },

  computed: {
    system_setting () {
      return this.$store.getters.system_setting;
    }
  },
  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    this.getMedicalRecordCategorys()
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetSupplierProductUpdateById({
        id
      }).then((res) => {
        // this.resetForm()
        // res.returnData.isDistribution = Boolean(res.returnData.isDistribution)
        // res.returnData.isScan = Boolean(res.returnData.isScan)
        // res.returnData.oldIsDistribution = Boolean(res.returnData.oldIsDistribution)
        // res.returnData.oldIsScan = Boolean(res.returnData.oldIsScan)
        this.form = res.returnData;
        this.form.sporadicNumber = this.form.sporadicNumber?this.form.sporadicNumber:''
        this.form.oldContractDate = ['', '']
        if (this.form.oldContractStartDate && this.form.oldContractEndDate) {
          this.form.oldContractDate = [this.form.oldContractStartDate, this.form.oldContractEndDate]
        }
        this.form.contractDate = ['', '']
        if (this.form.contractStartDate && this.form.contractEndDate) {
          this.form.contractDate = [this.form.contractStartDate, this.form.contractEndDate]
        }
        this.initWorkFlowProperty(this.form);
      });
    },
    // // 保存
    // submit () {
    //   this.$refs["form"].validate((valid) => {
    //     if (!valid) {
    //       return false;
    //     }
    //     SaveSupplierProduct(this.form).then((res) => {
    //       this.$my_message(`执行成功`, "success");
    //       sessionStorage.setItem("editMode", 0);
    //       this.$router.push({ path: this.getMainPath(this.$route.path) });
    //     });
    //   });
    // },
    resetForm () {
      this.form = {
        id: 0,
        "hospitalName": this.baseConfig.HospitalName,
        "productId": '',
        "productName": '',
        "countryNo": "",
        "productionRangeId": '',
        productCommonName: '',
        categoryId: '',
        productCategoryName: '',
        "productionRangeName": '',
        "manufacturerId": '',
        "manufacturerName": '',
        "specId": '',
        "specName": '',
        "supplierId": '',
        "supplierName": '',
        "remark": "",
        isEnabled: 1,
        useTime: 1,
        category: 1,
        medicalInsuranceCategoryId: '',
        medicalInsuranceCategoryNo: '',
        medicalInsuranceCommonName: '',
        texture: '',
        properties: '',
        singleProductName: '',
        productCode: '',
        saleCategory: 0,
        medicalInsuranceCategoryLongNo: '',
        patientCategory: '',
        details: [],
        supplierCertDetails: [],
        manufacturerCertDetails: [],
        productRegistCertDetails: [],
        updateUserName: this.userInfo.name,
        createdUserName: this.userInfo.name,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),

        firstCategory: '',
        secondCategory: '',
        thirdCategory: '',
        productionPlaceType: '',
        storageMode: 0,
        dangerLevel: '',
        contractNo: '',
        otherCategoryId: '',
        otherCategoryName: '',
        contractDate: ['', ''],
        contractStartDate: '',
        contractEndDate: '',
        isSelected: '',
        isKeySupervision: '',
        isEpidemicPreventionMaterials: '',
        isRfid: '',

        oldFirstCategory: '',
        oldSecondCategory: '',
        oldThirdCategory: '',
        oldProductionPlaceType: '',
        oldStorageMode: 0,
        oldDangerLevel: '',
        oldContractNo: '',
        oldOtherCategoryId: '',
        oldOtherCategoryName: '',
        oldContractDate: ['', ''],
        oldContractStartDate: '',
        oldContractEndDate: '',
        oldIsSelected: '',
        oldIsKeySupervision: '',
        oldIsEpidemicPreventionMaterials: '',
        oldIsRfid: '',
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    approve (state) {
      if (state == 4 && !this.form.reason) {
        this.$my_message('请填写拒绝原因', 'error');
        return;
      }
      
      ApproveSupplierProductUpdate({
        id: this.form.id,
        state,
        reason: this.form.reason,
        patientCategory:this.form.patientCategory,
        sporadicNumber:this.form.sporadicNumber?this.form.sporadicNumber:0,
        archiveType:this.form.archiveType,
        
      })
        .then(res => {
          // this.getData();
          // if (!res.successful) {
          //   return;
          // }

          // this.editVisible = false;
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
          this.$my_message(`审批成功`, 'success');
        })
    },
    // 审批证件
    handleApprove (row, state) {
      if (state == 4 && !row.reason) {
        this.$my_message(`请填写拒绝原因`, "warning");
        return;
      }
      ApproveSupplierProductUpdateCertDetail({
        id: row.id,
        state,
        // remark1
        reason: row.reason,
      })
        .then(res => {
          this.$my_message(`审批成功`, "success");
          this.handleUpdate(this.form.id)
        })
    },
    privewImg (file) {
      this.dialogVisible = true;
      this.fileId = file.id;
      this.fileName = file.name;
    },
    closeImageViewer () {
      this.dialogVisible = false;
    },
    distributionBatchChange (val) {
      var data = this.STATIC_DistributionBatchs.find((e) => e.id == val);
      if (data) {
        this.form.contractNo = data.contractNo;
        // this.form.contractDate = [data.startDate, data.endDate]

        if (data.startDate) {
          this.$set(this.form, "contractDate", [data.startDate, data.endDate]);
        } else {
          this.$set(this.form, "contractDate", ["", ""]);
        }
      } else {
        this.form.contractNo = "";
        this.$set(this.form, "contractDate", ["", ""]);
      }
      this.dateChange(this.form.contractDate);
    },

  },
};
</script>

<style lang="scss" scoped>
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}

.cont-list {
  justify-content: normal;

  .prompt {
    color: #ffcd00;
    font-size: 14px;
    margin-left: 10px;
    margin-top: 3px;
  }
}

.packNumBox /deep/.el-form-item__content {
  display: flex !important;
}
</style>
